
const digest = '3479c8715a5c1a1a28f57b880398d3180509f9bdfa82659de624232dbb379b0e';
const classes = {"wrapper":"_wrapper_jlske_1","text":"_text_jlske_15"};
const css = `._wrapper_jlske_1 {
  background-color: #ffe1e1;
  padding: 10px 24px;
  border-radius: 9px;
  font-weight: 600;
  color: #8b2e2e;
  border: 1px solid #8b2e2e;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
}
._wrapper_jlske_1 ._text_jlske_15 {
  flex: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  